import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { Spinner } from '@shared/ui'
import { ToastProvider } from '@shared/ui/Toast/Toast'
import { TooltipProvider } from '@shared/ui/Tooltip/TooltipProvider'
import { AuthProvider } from './providers/AuthProvider'
import { I18nProvider } from './providers/I18nProvider'
import { QueryProvider } from './providers/QueryProvider'
import { router } from './router'

export function App() {
  return (
    <QueryProvider>
      <I18nProvider>
        {/* Translations load on demand (per language+namespace); hold first paint
            with a spinner until the active language's resources resolve. */}
        <Suspense
          fallback={
            <div className="flex min-h-screen items-center justify-center">
              <Spinner />
            </div>
          }
        >
          <AuthProvider>
            <TooltipProvider>
              <ToastProvider>
                <RouterProvider router={router} />
              </ToastProvider>
            </TooltipProvider>
          </AuthProvider>
        </Suspense>
      </I18nProvider>
    </QueryProvider>
  )
}
